import { useState } from "react";
import { useOutletContext, useSearchParams } from "react-router-dom";
import Partners from "./Partners";
import PartnerTariffs from "./PartnerTariffs";
import Tariffs from "./Tariffs";
import "./PartnersHub.css";

export default function PartnersHub() {
    const { me } = useOutletContext() || {};
    const tabs = me?.tabs || [];
    const has = (k) => tabs.some((t) => t.key === k);

    const [searchParams, setSearchParams] = useSearchParams();
    const initial = searchParams.get("view") || "partners";
    const [view, setView] = useState(initial);

    const items = [
        { key: "partners", label: "Партнёры" },
        ...(has("partner-tariffs") ? [{ key: "partner-tariffs", label: "Тарифы партнёра" }] : []),
        ...(has("tariffs") ? [{ key: "tariffs", label: "Тарифы" }] : []),
    ];

    const select = (k) => {
        setView(k);
        // сохраняем выбранную под-вкладку в URL, но чистим лишние параметры
        setSearchParams(k === "partners" ? {} : { view: k }, { replace: true });
    };

    return (
        <div className="partners-hub">
            {/* Сегментированный контрол — тот же, что на других страницах с под-вкладками */}
            <div className="segs" role="tablist">
                {items.map((it) => (
                    <button
                        key={it.key}
                        type="button"
                        role="tab"
                        aria-selected={view === it.key}
                        className={"seg" + (view === it.key ? " active" : "")}
                        onClick={() => select(it.key)}
                    >
                        {it.label}
                    </button>
                ))}
            </div>

            <div className="hub-body">
                {view === "partners" && <Partners />}
                {view === "partner-tariffs" && has("partner-tariffs") && <PartnerTariffs />}
                {view === "tariffs" && has("tariffs") && <Tariffs />}
            </div>
        </div>
    );
}
